import React, { FunctionComponent, ReactNode } from 'react';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

type ConfirmationModalProps = {
    onClose?: () => void;
    onDismiss?: () => void;
    contentTitle: string;
    content: string | ReactNode;
    buttonContent?: string;
    cancelButtonContent?: string;
};
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        footer: {
            '& button': {
                margin: theme.spacing(1),
            },
        },
        dismissButton: {
            backgroundColor: '#005084 !important',
            color: '#fff',
            '&:hover': {
                backgroundColor: '#005084',
                color: '#fff',
            },
        },
        textColor: {
            color: '#484848',
        },
    }),
);
const ConfirmationModal: FunctionComponent<ConfirmationModalProps> = ({ ...props }) => {
    const { onDismiss, onClose, contentTitle, content, buttonContent, cancelButtonContent } = props;
    const classes = useStyles();

    return (
        <div>
            <DialogTitle classes={{ root: classes.textColor }}>{contentTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText classes={{ root: classes.textColor }}>{content}</DialogContentText>
            </DialogContent>
            <DialogActions className={classes.footer}>
                <Button disableElevation classes={{ text: classes.textColor }} onClick={onClose}>
                    {!!cancelButtonContent ? cancelButtonContent : 'Cancel'}
                </Button>
                <Button
                    disableElevation
                    variant="contained"
                    onClick={onDismiss}
                    className={classes.dismissButton}
                    autoFocus
                >
                    {!!buttonContent ? buttonContent : 'Yes, Leave'}
                </Button>
            </DialogActions>
        </div>
    );
};
export default ConfirmationModal;
